import firebase from 'firebase/app';
import "firebase/storage" 
import "firebase/firestore"
import 'firebase/auth'; 

const firebaseConfig = {
  apiKey: "AIzaSyAfER37JplOCzuj2chZGzHXjgXoXeUloJ0",
  authDomain: "uobnotes-1b908.firebaseapp.com",
  databaseURL: "https://uobnotes-1b908.firebaseio.com",
  projectId: "uobnotes-1b908",
  storageBucket: "uobnotes-1b908.appspot.com",
  messagingSenderId: "124102939827",
  appId: "1:124102939827:web:8511042851b996a1fbccc6",
  measurementId: "G-N5ZJ09GPH9"
  };

 export const app = firebase.initializeApp(firebaseConfig);
 export const db = firebase.firestore()
